module.exports = __webpack_public_path__ + "337af42ecfffdc874e58c8e85df5fe8b.pdf";